import React from "react";
import { CloudDownloadOutlined, CloudUpload } from "@mui/icons-material";
import { Box } from "@mui/material";

import { StackedNavigationButton, SvgIcon, useStackedNavigationContext } from "fond/widgets";
import StackedNavigationHeader from "fond/widgets/StackedNavigation/StackedNavigationHeader";

interface BoundaryPanelProps {
  hasBoundary: boolean;
}

const BoundaryPanel: React.FC<BoundaryPanelProps> = ({ hasBoundary }) => {
  const { open, clear } = useStackedNavigationContext();

  const handleOnDrawPolygonButtonClick = () => {
    open("boundary-draw");
  };
  const handleOnUploadPolygon = () => {
    open("boundary-upload");
  };
  const handleOnImportClick = () => {
    open("boundary-import");
  };

  const onBack = () => {
    clear();
  };

  return (
    <Box>
      <StackedNavigationHeader title="Boundary" onBackButtonClick={onBack} />
      <StackedNavigationButton
        data-testid="draw-new-polygon-button"
        icon={<SvgIcon icon="polygon" />}
        title="Draw boundary"
        subtitle="Draw your own boundary on the map"
        onClick={handleOnDrawPolygonButtonClick}
      />
      <StackedNavigationButton
        data-testid="upload-boundary-button"
        icon={<CloudUpload />}
        title="Upload"
        subtitle="Upload your own boundary"
        onClick={handleOnUploadPolygon}
      />
      <StackedNavigationButton
        data-testid="import-button"
        icon={<CloudDownloadOutlined />}
        title="Import associated data"
        subtitle="Import data based on your boundary"
        onClick={handleOnImportClick}
        disabled={!hasBoundary}
      />
    </Box>
  );
};

export default BoundaryPanel;
